<template>
  <div>
    <filter-slot
      :filter="filters"
      :filterPrincipal="filterPrincipal"
      :paginate="paginate"
      @reload="$refs['ref-table-travel-orders'].refresh()"
    >
      <template #table>
        <b-table
          ref="ref-table-travel-orders"
          :per-page="paginate.perPage"
          :current-page="paginate.currentPage"
          sticky-header="50vh"
          small
          class="position-relative font-small-3"
          table-class="text-nowrap"
          :busy.sync="isBusy"
          :items="myProvider"
          :fields="getFields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :empty-text="$t('No matching records found')"
        >
          <template #table-busy>
            <b-skeleton-table
              :headers="fields"
              :rows="paginate.perPage"
              :columns="fields.length"
              :table-props="{ bordered: true, striped: true }"
            />
          </template>

          <template #cell(name)="data">
            <div class="d-flex">
              <span class="">
                {{ data.item.name }}
              </span>
            </div>
          </template>

          <template #cell(accounting_account)="data">
            <div>
              <b-badge
                v-if="data.item.accounting_account == null"
                variant="light-danger"
              >
                {{ $t("Not assigned") }}
              </b-badge>
              <div v-else>
                <span class="text-primary"> {{ data.item.code }} </span>
                <span> - {{ data.item.accounting_account }} </span>
              </div>
            </div>
          </template>

          <template #cell(created_at)="data">
            <div class="d-flex">
              <span style="opacity: 0.8">
                {{ data.item.created_at | myGlobalDay }}
              </span>
            </div>
          </template>

          <template #cell(balance)="data">
            <div class="d-flex">
              <span class="text-primary">
                {{ data.item.account_currency == "pen" ? "S/" : "$" }}
              </span>
              <span class="text-primary" style="margin-left: 5px">
                {{ data.item.balance | currency }}
              </span>
            </div>
          </template>

          <template #cell(status)="data">
            <div>
              <b-badge :variant="resolveStyleStatus(data.item.status)">
                {{ $t(data.item.status) }}
              </b-badge>
            </div>
          </template>

          <template #cell(created_by)="data">
            <div class="d-flex flex-column">
              <span>
                <tabler-icon icon="UserIcon" class="text-primary" />
                {{ data.item.created_name }}
              </span>
              <span style="opacity: 0.8">
                <tabler-icon icon="CalendarIcon" class="text-success" />
                {{ data.item.created_at | myGlobalDay }}
              </span>
            </div>
          </template>
          <template #cell(actions)="data">
            <!-- Edit travel -->
            <feather-icon
              icon="EditIcon"
              size="18"
              v-b-tooltip.hover.v-warning
              :title="$t('Edit travel')"
              class="text-warning cursor-pointer"
              @click="editTravelOrder(data.item)"
            />
          </template>
        </b-table>
      </template>
    </filter-slot>

    <TravelOrderModal
      v-if="modalTravel"
      :travelId="travelId"
      @refreshTable="
        modalTravel = false;
        $refs['ref-table-travel-orders'].refresh();
      "
      @hideModal="modalTravel = false"
    />
  </div>
</template>

<script>
import FilterSlot from "@/views/commons/filter-slot/FilterSlot.vue";
import Fields from "@/views/commons/bank-accounts/data/fields.data.js";
import Fiters from "@/views/operations/views/travel-orders/data/filters.data.js";

import BankAccountService from "@/views/commons/bank-accounts/services/bank-account.service.js";
import TravelOrderModal from "@/views/operations/views/travel-orders/components/modals/TravelOrderModal.vue";

export default {
  components: {
    FilterSlot,
    TravelOrderModal,
  },
  data() {
    return {
      filters: [],
      fields: Fields,
      isBusy: false,
      sortBy: "",
      sortDesc: true,
      filterPrincipal: {
        type: "input",
        inputType: "text",
        placeholder: "Search...",
        model: "",
      },
      paginate: {
        from: 0,
        to: 0,
        of: 0,
        perPage: 10,
        currentPage: 1,
      },
      travelId: null,
      modalTravel: false,
    };
  },
  created() {},
  computed: {
    getFields() {
      return this.fields.filter((f) => f.visible);
    },
  },
  methods: {
    async myProvider(ctx) {
      this.addPreloader();
      try {
        const params = {
          page: ctx.currentPage,
          perpage: ctx.perPage,
          order: 1,
          orderby: ctx.sortDesc ? "Desc" : "Asc",
          search_txt: this.filterPrincipal.model,
          status: 1,
          from: null,
          to: null,
        };

        const { data } = await BankAccountService.getBankAccounts(params);
        console.log(data);
        this.paginate.from = data.from;
        this.paginate.to = data.to;
        this.paginate.of = data.total;
        this.paginate.perPage = data.per_page;
        this.paginate.currentPage = data.current_page;

        return data.data;
      } catch (error) {
        console.log(error);
        return [];
      } finally {
        this.removePreloader();
      }
    },

    createTravel() {
      this.travelId = null;
      this.modalTravel = true;
    },

    editTravelOrder(item) {
      this.travelId = item.id;
      this.modalTravel = true;
    },

    viewDocumentOrders(item) {
      console.log("item: ", item);
      this.travelId = item.id;
      this.modalDocumentOrders = true;
    },

    resolveStyleStatus(status) {
      let style = "light-success";
      switch (status) {
        case "activo":
          style = "light-success";
          break;
        case "inactivo":
          style = "light-danger";
          break;
        default:
          break;
      }
      return style;
    },
  },
};
</script>

<style>
.width-5 {
  width: 70px;
}
</style>